// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
    durationMiliseconds: {
        defaultMessage: 'less than a second',
        id: 'sensor-logs.duration-miliseconds'
    },
    durationMinutes: {
        defaultMessage: `{minutes}m {seconds}s`,
        id: 'sensor-logs.duration-minutes'
    },
    durationHours: {
        defaultMessage: `more than {hours, plural,
    			one {an hour}
    			other {# hours}
    		}`,
        id: 'sensor-logs.duration-hours'
    }
});



// WEBPACK FOOTER //
// ./src/core/utils/periods/intl.js